import { render, staticRenderFns } from "./AdminTypesTables.vue?vue&type=template&id=65b38b30"
import script from "./AdminTypesTables.vue?vue&type=script&lang=js"
export * from "./AdminTypesTables.vue?vue&type=script&lang=js"
import style0 from "./AdminTypesTables.vue?vue&type=style&index=0&id=65b38b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports